export default __webpack_public_path__ + "static/media/breakfast_1.11a1520c.jpg";